<template>
  <div class="relative select-none">
    <div class="absolute top-full left-0 w-full transform transition-transform duration-100 overflow-hidden" :class="{ '-translate-y-full': !visible }">
      <slot name="menu" />
    </div>
    <div class="h-full" @click.stop="visible = !visible">
      <slot name="button" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'UiDropdown',
    data() {
      return {
        visible: false,
      }
    },
  }
</script>
